import CustomNotificationContextContainer from './CustomNotificationContext.container';
import { CustomNotificationProvider, useCustomNotifications } from './CustomNotificationContext';
export default CustomNotificationContextContainer(CustomNotificationProvider);
export { useCustomNotifications };
